<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                class="text--main-yellow"
                v-bind="attrs"
                v-on="on"
                text
            >
                {{ $t('history') }}
            </v-btn>
        </template>
        <v-list dense>
            <v-list-item v-for="(item, idx) in history" :key="idx">
                <v-list-item-title>
                    <v-btn text :href="getLink(item.id)">
                        {{ item.title }}
                    </v-btn>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    name: "ContractHistory",
    props:['history', 'historyType', 'orderId'],
    data() {
        return {
            buyerLink: '/download/contract/buyer',
            buyerType: 'buyer',
            sellerLink: '/download/contract/seller',
            sellerType: 'seller',
        }
    },
    methods: {
        getLink(id) {
            switch (this.historyType) {
                case this.buyerType:
                    return `${this.buyerLink}?contractID=${id}&orderID=${this.orderId}`;
                case this.sellerType:
                    return `${this.sellerLink}?contractID=${id}`;
            }
        }
    }
}
</script>

<style scoped>

</style>
